import { gql } from '@apollo/client'

export const LANGUAGE_SWITCH = gql`
  fragment languageSwitch on LanguageSwitchData {
    language
    url
    current
  }
`;
